// extracted by mini-css-extract-plugin
export var rateTable = "_55-0";